import { Menu } from "@/types/menu";

type MenuTranslations = {
  home: string;
  catalogue: string;
  howItWorks: string;
  more: string;
  findPartner: string;
  pricing: string;
  trackOrder: string;
  benefitsCustomer: string;
  benefitsPartner: string;
  ownAndEarn: string;
  benefitsProducer: string;
  login: string;
};

const getMenuData = (t: MenuTranslations): Menu[] => [
  { id: 1, title: t.home, path: "/", newTab: false },
  { id: 2, title: t.pricing, path: "/pricing", newTab: false },
  { id: 3, title: t.howItWorks, path: "/how-it-works", newTab: false },
  {
    id: 4,
    title: t.more,
    newTab: false,
    submenu: [
      { id: 40, title: t.benefitsCustomer, path: "/benefits-for-customers", newTab: false },
      { id: 41, title: t.ownAndEarn, path: "/own-and-earn", newTab: false },
      { id: 42, title: t.benefitsProducer, path: "/benefits-for-producers", newTab: false },
      { id: 43, title: t.catalogue, path: "/film-catalogue", newTab: false },
      { id: 44, title: t.login, path: "/login", newTab: false },
      { id: 45, title: t.trackOrder, path: "/track-order", newTab: false },
      { id: 46, title: t.findPartner, path: "/find-a-stick-to-rent", newTab: false },
    ],
  },
];

export default getMenuData;
